import { BaseFetch } from "../main-model";
export default class ExportPP8Model extends BaseFetch {
  getExportPP8By = (data) =>
    this.authFetch({
      url: "export-pp8/getExportPP8By",
      method: "POST",
      body: JSON.stringify(data),
    });
}
